import React from 'react';
import { motion } from 'framer-motion';
import { ButtonSecondary } from './UI';
export const Hero = () => {
  return <section className="relative overflow-hidden bg-gradient-to-br from-brand-grayBg via-white to-brand-grayBg" data-id="element-16">
      {/* Subtle purple gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-brand-purple/5 via-transparent to-brand-purple/3 pointer-events-none" data-id="element-17"></div>

      <div className="relative z-10 max-w-[1200px] mx-auto px-6 md:px-12 py-20 md:py-28" data-id="element-18">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-19">
          {/* Left — Text Content */}
          <motion.div className="flex-1 text-center md:text-left" initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} data-id="element-20">
            <div className="flex justify-center md:justify-start gap-2 flex-wrap mb-8" data-id="element-21">
              <span className="border border-brand-purple/30 bg-brand-purple/5 rounded-full px-4 py-[5px] text-[0.75rem] font-semibold tracking-[1.5px] uppercase text-brand-purple" data-id="element-22">
                Guía Digital
              </span>
              <span className="border border-brand-purple/30 bg-brand-purple/5 rounded-full px-4 py-[5px] text-[0.75rem] font-semibold tracking-[1.5px] uppercase text-brand-purple" data-id="element-23">
                Paso a Paso
              </span>
              <span className="border border-brand-purple/30 bg-brand-purple/5 rounded-full px-4 py-[5px] text-[0.75rem] font-semibold tracking-[1.5px] uppercase text-brand-purple" data-id="element-24">
                Acceso Inmediato
              </span>
            </div>

            <h1 className="font-serif text-[clamp(2.2rem,5vw,3.6rem)] leading-[1.1] text-brand-dark mb-6 font-bold" data-id="element-25">
              Ya investigaste suficiente.
              <br data-id="element-26" />
              <span className="text-brand-purple" data-id="element-27">Es hora de ejecutar.</span>
            </h1>

            <p className="text-[1.15rem] text-brand-dark/70 max-w-[520px] mx-auto md:mx-0 mb-4 leading-relaxed" data-id="element-28">
              La guía práctica que te da el mapa completo para crear tu empresa
              en Estados Unidos — sin perderte, sin errores costosos.
            </p>

            <p className="text-[0.95rem] text-brand-purple/70 italic max-w-[480px] mx-auto md:mx-0 mb-8" data-id="element-29">
              Diseñada para emprendedores latinos que ya saben que quieren
              hacerlo… pero necesitan claridad para hacerlo bien.
            </p>

            <div className="flex flex-col sm:flex-row items-center md:items-start gap-4" data-id="element-30">
              <ButtonSecondary text="👉 Descargar Mi Guía — $36" href="https://shop.beacons.ai/inkovacreation/0de4a31b-dafb-4911-b0f5-64f146eb7e48" data-id="element-31" />
            </div>

            <p className="mt-4 text-[0.82rem] text-brand-dark/40 font-medium" data-id="element-32">
              Descarga directa · PDF completo · Sin complicaciones
            </p>
          </motion.div>

          {/* Right — Image */}
          <motion.div className="flex-1 flex justify-center md:justify-end" initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} data-id="element-33">
            <div className="relative" data-id="element-34">
              {/* Soft glow behind image */}
              <div className="absolute -inset-8 bg-brand-purple/8 rounded-3xl blur-3xl pointer-events-none" data-id="element-35"></div>
              <img src="https://cdn.magicpatterns.com/uploads/dnTz9hyoom8d9dkKLE4pY3/heylloyd-image-1776437525225.png" alt="Guía Digital Ruta USA 360" className="relative w-full max-w-[560px] rounded-2xl shadow-[0_20px_60px_rgba(90,69,121,0.2)]" data-id="element-36" />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom subtle border */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-brand-purple/15 to-transparent" data-id="element-37"></div>
    </section>;
};